export default __webpack_public_path__ + "static/media/faq_illustration.fc63303a.png";